export default "__VITE_ASSET__DrAb6RIb__"